export default "__VITE_ASSET__BmZ0Fblv__"